import React from "react"
import { useTranslation } from "react-i18next"

import { TextField } from "components"
import classes from "./PopdOrderNote.module.scss"

const PopdOrderNote = props => {
  const {
    formErrors,
    paymentDetails,
    setPaymentDetails
  } = props

  const [t] = useTranslation()

  const handleChange = (e) => {
    const value = e.target.value

    setPaymentDetails(prev => ({ ...prev, note: value }))
  }

  return (
    <TextField
      componentClass="textarea"
      type="text"
      maxLength={300}
      label={t("توضیحات_سفارش")}
      className={classes["input"]}
      value={paymentDetails.note}
      onChange={handleChange}
      error={formErrors.note}
    />
  )
}

export default PopdOrderNote